import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import {
  // clearCartSingle,
  // cartUpdate,
  cartLocal,
} from "../../actions/productActions";

class CartRender extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cdata: props.cdata,
    };

    this.cartChange = this.cartChange.bind(this);
    this.cartRender = this.cartRender.bind(this);
    this.clearCartSingle = this.clearCartSingle.bind(this);
  }

  componentDidMount() {
    // console.log(this.props);
  }

  // componentWillReceiveProps(nextprops) {
  // let dataprops = nextprops;
  //console.log(dataprops);
  // if (
  //   nextprops.loading === false &&
  //   nextprops.add_to_cart !== null &&
  //   Object.keys(nextprops.add_to_cart.data).length === 0
  // ) {
  //   this.props.updateCart(null);
  // }

  // if (
  //   nextprops.loading === false &&
  //   nextprops.add_to_cart !== null &&
  //   nextprops.add_to_cart.success &&
  //   Object.keys(nextprops.add_to_cart.data).length > 0
  // ) {
  //   this.setState({ cdata: nextprops.cdata });
  // }

  componentDidUpdate(prevProps) {
    if (prevProps.cdata !== this.props.cdata) {
      this.setState({ cdata: this.props.cdata });
    }
  }

  cartChange = (state, key, stock, id) => {

    // console.log(this.state.cdata);
    let oldData = this.state.cdata;
    // console.log(stock);
    if (state) {
      // if (oldData[key].quantity >= stock) {
      //  return;
      // } else {
      let newQty = parseInt(oldData[key].quantity) + 1;
      oldData[key].price = newQty * (oldData[key].price / oldData[key].quantity);
      oldData[key].quantity = newQty;
      // }
    } else {
      if (oldData[key].quantity > 1) {
        let newQty = parseInt(oldData[key].quantity) - 1;
        oldData[key].price = newQty * (oldData[key].price / oldData[key].quantity);
        oldData[key].quantity = newQty;
      }
    }

    // if (localStorage.login) {
    //   this.props.cartUpdate(id, oldData[key]);
    // } else {
    //   console.log(oldData[key].quantity);
    //   localStorage.setItem("cart", JSON.stringify(oldData));
    //   this.props.cartLocal(oldData);
    // }

    localStorage.setItem("cart", JSON.stringify(oldData));
    this.props.cartLocal(oldData);

    this.setState({ cdata: oldData });
  };

  clearCartSingle = (id) => {
    // console.log(this.state.cdata);
    let oldData = this.state.cdata;
    // if (localStorage.login) {
    //   this.props.clearCartSingle(id);
    // } else {
    //   if (oldData.length > 0) {
    //     for(let i = 0; i < oldData.length; i++) {
    //       if(oldData[i]['id'] === id) {
    //         oldData.splice(i, 1);
    //       }
    //     }
    //     this.props.cartLocal(oldData);
    //     localStorage.setItem('cart', JSON.stringify(oldData));
    //   }
    //    this.props.cartLocal(oldData);
    // }

    if (oldData.length > 0) {
      for (let i = 0; i < oldData.length; i++) {
        if (oldData[i]['id'] === id) {
          oldData.splice(i, 1);
        }
      }
      this.props.cartLocal(oldData);
      localStorage.setItem('cart', JSON.stringify(oldData));
    }
    // console.log(this.state.cdata);
  };

  cartRender = () => {
    let html = [];
    let cdata = this.state.cdata;
    // console.log(cdata);
    if (cdata && Object.keys(cdata).length > 0) {
      Object.keys(cdata).map((key, index) => {
        let grouped = {};
        if (cdata[key]?.combo_products_set?.length > 0) {
          grouped = cdata[key].combo_products_set.reduce((acc, item) => {
            if (!acc[item.base_product_name]) {
              acc[item.base_product_name] = [];
            }
            acc[item.base_product_name].push(item);
            return acc;
          }, {});
        }
        // html.push(
        //   <div key={key} className="groups">
        //     <div className="group">
        //       <div className="left">{cdata[key].product[0].name}</div>
        //       <span
        //         onClick={() => this.clearCartSingle(cdata[key].id)}
        //         className="right"
        //       >
        //         <i className="delete-icon"></i>
        //       </span>
        //     </div>
        //     <div className="group">
        //       <div className="left">
        //         <div className="num-action md">
        //           <span
        //             className="btn"
        //             onClick={(e) =>
        //               this.cartChange(
        //                 false,
        //                 key,
        //                 cdata[key].product[0].stock,
        //                 cdata[key].id
        //               )
        //             }
        //           >
        //             -
        //           </span>
        //           <span className="value"> {cdata[key].quantity}</span>
        //           <span
        //             className="btn"
        //             onClick={(e) =>
        //               this.cartChange(
        //                 true,
        //                 key,
        //                 cdata[key].product[0].stock,
        //                 cdata[key].id
        //               )
        //             }
        //           >
        //             +
        //           </span>
        //         </div>
        //       </div>
        //       <div className="right">{cdata[key].price}</div>
        //     </div>
        //   </div>
        // )
        if (cdata[key].product_name) {
          let innerhtml = [];
          const availability = this.props.api_availability?.find(
            p => p.product_id === cdata[key].product_id
          ) || {};

          const selectedModifiers = availability.localProduct?.selectedModifiers || [];

          const variationIds = (cdata[key].variation_id || "")
            .split(",")
            .map(id => Number(id.trim()));

          const modifierMap = selectedModifiers.reduce((acc, mod) => {
            acc[mod.id] = mod;
            return acc;
          }, {});

          const apiFlags = availability.localProduct || {};

          const isBlockedForSelling =
            apiFlags.not_for_pickup_delivery === 1 ||
            apiFlags.not_for_selling === 1 ||
            apiFlags.out_of_stock === 1;
          if (cdata[key].variation_name.length) {
            const variationQuantities = (cdata[key].variation_quantity || "")
              .split(",")
              .map(q => parseInt(q.trim()) || 1);
            innerhtml.push(
              <div key={`${cdata[key].id}_variation`} className="left cart_variation" style={{
                color: "#484848",
                fontSize: "12px",
                paddingBottom: "10px"
              }}>
                {cdata[key].variation_name
                  .split(",")
                  .map((name, idx) => {

                    const mod = modifierMap[variationIds[idx]];
                    const modQty = variationQuantities[idx] || 1;

                    const isOutOfStock = mod?.out_of_stock === 1;
                    const isUnavailable =
                      !isOutOfStock &&
                      (mod?.not_for_selling === 1 || mod?.not_for_delivery === 1);

                    return (
                      <div
                        key={idx}
                        style={{
                          display: "flex",
                          alignItems: "center", gap: "6px",
                          marginBottom: "6px"
                        }}
                      >
                        <span style={{
                          minWidth: "50px",   // 👈 standard column width
                          display: "inline-block",
                          whiteSpace: "nowrap"
                        }}>{name.trim()}{modQty > 1 ? ` ×${modQty}` : ""}</span>

                        {(isOutOfStock || isUnavailable) && (
                           <button
  className="replace-badge"
  style={{ borderRadius: "12px", marginLeft: "70px", backgroundColor: "#f59e0b", color: "#000000", border: "1px solid #000000" }}
  onClick={() => {
    const variationIds = cdata[key].variation_id.split(",");
    console.log("Replace button clicked. Data sent to showChooseModal:", {
      cartItemId: cdata[key].id,
      replaceIndex: idx,
      product: {
        id: cdata[key].product_id,
        name: cdata[key].product_name,
        price: cdata[key].product_price,
        image: cdata[key].image,
      },
      oldVariationId: variationIds[idx],
    });
    this.props.showChooseModal({
      cartItemId: cdata[key].id,     
      replaceIndex: idx,             
      product: {
        id: cdata[key].product_id,
        name: cdata[key].product_name,
        price: cdata[key].product_price,
        image: cdata[key].image,
      },
      oldVariationId: variationIds[idx],
    });
  }}
>
  Replace
</button>
                        )}

                        {isOutOfStock && (
                          <span className="out-of-stock-badge" style={{ backgroundColor: "#e01e26", color: "#ffffff", borderRadius: "12px", padding: "3px 10px", fontSize: "11px", fontWeight: "600", display: "inline-block", whiteSpace: "nowrap" }}>Out of Stock</span>
                        )}

                        {isUnavailable && (
                          <span className="unavailable-badge" style={{ backgroundColor: "#9ca3af", color: "#000000", borderRadius: "12px", padding: "3px 10px", fontSize: "11px", fontWeight: "600", display: "inline-block", whiteSpace: "nowrap" }}>Unavailable</span>
                        )}
                      </div>
                    );
                  })}
              </div>
            )
          }

          // console.log(cdata[key].id);

          html.push(
            <div key={cdata[key].id} className="groups">
              <div className="group">
                <div className="left">{cdata[key].product_name}</div>
                {/* Delete Icon is big that size is reduced for decent view */}
                <span
                  onClick={() => this.clearCartSingle(cdata[key].id)}
                  className="right"
                  style={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}
                >
                  <i
                    className="delete-icon"
                    style={{
                      width: "15px",
                      height: "15px",
                      backgroundSize: "contain", // dustbin size increment
                      backgroundRepeat: "no-repeat",
                      display: "inline-block"
                    }}
                  ></i>
                </span>
              </div>
              {isBlockedForSelling && (
                <span
                  style={{
                    background: "#ffffff",
                    color: "#f97f1bff",
                    border: "2px solid #f97f1bff",
                    fontSize: "12px",
                    padding: "2px 6px",
                    borderRadius: "4px",
                    textTransform: "uppercase",
                    fontWeight: "bold",
                    display: "inline-block",
                    marginTop: "5px",
                    marginBottom: "5px",
                  }}
                >
                  Unavailable
                </span>
              )}
              {cdata[key]?.combo_products?.length > 0 && (
                <div
                  className="left combo"
                  style={{ color: "#777", fontSize: "12px", paddingTop: "4px" }}
                >
                  ({cdata[key].combo_products.map(p => `${p.quantity} ${p.name}`).join(" + ")})
                </div>
              )}

              {cdata[key]?.combo_products_set?.length > 0 && (
                <div
                  className="left combo"
                  style={{ color: "#777", fontSize: "12px", paddingTop: "4px" }}
                >
                  {Object.keys(grouped).map((groupName) => {
                    const groupedModifiers = grouped[groupName].reduce((acc, item) => {
                      const key = item.name;
                      if (!acc[key]) {
                        acc[key] = { ...item, quantity: item.quantity ?? 1 };
                      } else {
                        acc[key].quantity += item.quantity ?? 1;
                      }
                      return acc;
                    }, {})
                    return (
                      <div key={groupName} style={{ marginBottom: "3px" }}>
                        <span style={{ fontWeight: "bold" }}>
                          {groupName}
                        </span>{" "}
                        (
                        {Object.values(groupedModifiers)
                          .map((p) => `${p.quantity ?? ""} ${p.name}`)
                          .join(" + ")}
                        )
                      </div>
                    )
                  })}
                </div>
              )}

              <div className="group">
                {innerhtml}
              </div>
              <div className="group">
                <div className="left">
                  <div className="num-action md">
                    <span
                      className="btn"
                      onClick={() => cdata[key].quantity > 1 && this.cartChange(false, key, cdata[key].id)}
                      style={{
                        cursor: cdata[key].quantity === 1 ? "not-allowed" : "pointer",
                        opacity: cdata[key].quantity === 1 ? 0.5 : 1,
                      }}
                    >
                      -
                    </span>
                    <span className="value"> {cdata[key].quantity}</span>
                    <span
                      className="btn"
                      onClick={(e) =>
                        this.cartChange(
                          true,
                          key,
                          cdata[key].id
                        )
                      }
                    >
                      +
                    </span>
                  </div>
                </div>
                <div className="right">{parseFloat(cdata[key].price).toFixed(2)}</div>
              </div>
            </div>
          )
        }
      });
    }
    //  console.log(menus);
    return html;
  };

  render() {
    // let cartRender = this.cartRender();
    return <>{this.cartRender()}</>;
  }
}

const mapStateToProps = (state) => ({
  add_to_cart: state.products.add_to_cart,
  loading: state.products.loading,
  api_availability: state.products.api_availability,
});
export default withTranslation()(
  connect(mapStateToProps, { cartLocal })(
    CartRender
  )
);
